import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';
import { UserRole } from '../../types';
import { useUnreadMessages } from '../../contexts/UnreadMessagesContext';

export const FloatingPillNav: React.FC = () => {
    const { user } = useAuth();
    const { totalUnreadCount } = useUnreadMessages();
    const isDomina = user?.role === UserRole.DOMINA;

    const dominaLinks = [
        { to: '/', icon: '🏠', label: 'Dashboard' },
        { to: '/clients', icon: '👥', label: 'Klienten' },
        { to: '/coaching', icon: '🧭', label: 'Coaching' },
        { to: '/tasks', icon: '✅', label: 'Aufgaben' },
        { to: '/structure', icon: '⏳', label: 'Struktur' },
        { to: '/calendar', icon: '🗓️', label: 'Kalender' },
        { to: '/timer', icon: '⏱️', label: 'Timer' },
        { to: '/messenger', icon: '💬', label: 'Messenger', badgeCount: totalUnreadCount },
        { to: '/audio-inputs', icon: '🎧', label: 'Flüsterraum' },
        { to: '/diary', icon: '📖', label: 'Tagebuch' },
        { to: '/reports', icon: '📜', label: 'Rapporte' },
        { to: '/payments', icon: '💰', label: 'Zahlungen' },
        { to: '/rules', icon: '👑', label: 'Regeln' },
        { to: '/media', icon: '🗂️', label: 'Mediathek' },
        { to: '/settings', icon: '⚙️', label: 'Einstellungen' },
    ];

    const subLinks = [
        { to: '/', icon: '🏠', label: 'Dashboard' },
        { to: '/coaching', icon: '🧭', label: 'Coaching' },
        { to: '/tasks', icon: '✅', label: 'Aufgaben' },
        { to: '/planning', icon: '⏳', label: 'Struktur' },
        { to: '/calendar', icon: '🗓️', label: 'Kalender' },
        { to: '/timer', icon: '⏱️', label: 'Timer' },
        { to: '/messenger', icon: '💬', label: 'Messenger', badgeCount: totalUnreadCount },
        { to: '/audio-inputs', icon: '🎧', label: 'Flüsterraum' },
        { to: '/diary', icon: '📖', label: 'Tagebuch' },
        { to: '/reports', icon: '📜', label: 'Rapport' },
        { to: '/rules', icon: '👑', label: 'Regeln' },
        { to: '/media', icon: '🗂️', label: 'Mediathek' },
        { to: '/profile', icon: '👤', label: 'Profil' },
        { to: '/settings', icon: '⚙️', label: 'Einstellungen' },
    ];

    const links = isDomina ? dominaLinks : subLinks;

    return (
        <div className="fixed bottom-5 inset-x-0 z-30 flex justify-center px-4 pointer-events-none">
            <div className="pointer-events-auto bg-surface/90 backdrop-blur-2xl border border-border-strong/40 p-2 rounded-full shadow-2xl max-w-full flex items-center gap-1.5 overflow-x-auto scrollbar-none transition-all duration-300 ring-1 ring-primary/20">
                {links.map((link) => (
                    <NavLink
                        key={link.to}
                        to={link.to}
                        className={({ isActive }) =>
                            `flex items-center gap-2 px-3.5 py-2 rounded-full text-xs font-bold transition-all whitespace-nowrap cursor-pointer ${
                                isActive
                                    ? 'bg-primary text-white shadow-glow shadow-primary/25'
                                    : 'text-text-secondary hover:text-text-main hover:bg-surface-light'
                            }`
                        }
                    >
                        <span className="text-sm">{link.icon}</span>
                        <span>{link.label}</span>
                        {link.badgeCount !== undefined && link.badgeCount > 0 && (
                            <span className="bg-rose-500 text-white text-[9px] font-bold rounded-full h-4 min-w-[16px] px-1 flex items-center justify-center animate-pulse">
                                {link.badgeCount > 9 ? '9+' : link.badgeCount}
                            </span>
                        )}
                    </NavLink>
                ))}
            </div>
        </div>
    );
};
